export default __webpack_public_path__ + "images/do-c05850db8e87e53a12689a7c273cc1c7.svg";